import { useEffect, useState } from 'react';
import setUiMessage from '../../../Utilities/Tostify';
import { post } from '../../Auths/AuthToken';
import DocumentTab from './DocumentTab';
import { useDispatch, useSelector } from 'react-redux';
import { handAllReferralDocs } from '../../../redux/slices/referralSlice';
import ConfirmDialog from '../../../Utilities/ConfirmDialog';

const AttachDocumentsPopup = ({
  patientId,
  selectedDocs,
  setSelectedDocs,
  closePopup,
}) => {
  const dispatch = useDispatch();
  const { allReferralDocs } = useSelector((store) => store.referral);
  const [activeTab, setActiveTab] = useState('patientFaceSheet');
  const [documentData, setDocumentData] = useState({
    faceSheet: [],
    results: [],
    documentss: [],
    progressNotes: [],
    clinicalSummary: [],
  });

  const [tabFilters, setTabFilters] = useState({
    results: { filterType: '90days', startDate: '', endDate: '' },
    documentss: { filterType: '90days', startDate: '', endDate: '' },
    progressNotes: { filterType: '90days', startDate: '', endDate: '' },
    clinicalSummary: { filterType: '90days', startDate: '', endDate: '' },
  });

  const [selectedChildDocs, setSelectedChildDocs] = useState(selectedDocs);
  const [alertPopup, setAlertPopup] = useState(false);
  const [reload, setReload] = useState(false);

  const handleReload = () => setReload(!reload);

  const toggleDocSelection = async (event, key, doc) => {
    if (activeTab === 'progressNotes' && event.target.checked) {
      try {
        const response = await post('api/commonTask/printPatientSoapNote', {
          patientId: patientId,
          soapNoteId: doc.id,
          withMsg: 1,
          mode: 'faxPopup',
        });
        if (response.status === 200) {
          doc = {
            ...doc,
            fileName: response.data.fileName,
            file_url: response.data.file_url,
          };
          setDocumentData((prev) => ({
            ...prev,
            progressNotes:
              prev.progressNotes.map((note) => {
                if (note.id === doc.id) return doc;
                return note;
              }) || [],
          }));
        } else return;
      } catch (error) {
        setUiMessage('err', error.message);
        return;
      }
    }
    setSelectedChildDocs((prev) => {
      const newSelection = { ...prev };
      if (newSelection[key]) delete newSelection[key];
      else newSelection[key] = doc;
      return newSelection;
    });
  };

  useEffect(() => {
    (async () => {
      try {
        const response = await post('api/commonTask/openPatientDocumentPopup', {
          patId: patientId,
        });
        if (response.status === 200) {
          setDocumentData({
            faceSheet: response.data.faceSheetData || [],
            results: response.data.resultsData || [],
            documentss: response.data.patDocsList || [],
            progressNotes: response.data.progressNotesList || [],
            clinicalSummary: response.data.reportList || [],
          });
        }
      } catch (error) {
        setUiMessage('err', error.message);
      }
    })();
  }, [patientId, reload]);

  useEffect(() => {
    const filters = tabFilters.results;
    // Avoid empty date range triggering request
    if (
      filters.filterType === 'range' &&
      (!filters.startDate || !filters.endDate)
    ) {
      // setUiMessage('err', 'Select Date');
      return;
    }
    // fetchFilteredData('results', filters);
    (async () => {
      try {
        const response = await post('api/commonTask/listResultsDocs', {
          patientId: patientId,
          mode: filters.filterType,
          fromDate: filters.filterType === 'range' ? filters.startDate : '',
          toDate: filters.filterType === 'range' ? filters.endDate : '',
        });
        setDocumentData((prev) => ({
          ...prev,
          results: response.data.resultsData || [],
        }));
      } catch (error) {
        setUiMessage('err', error.message);
      }
    })();
  }, [patientId, tabFilters.results]);

  useEffect(() => {
    const filters = tabFilters.documentss;
    // Avoid empty date range triggering request
    if (
      filters.filterType === 'range' &&
      (!filters.startDate || !filters.endDate)
    ) {
      // setUiMessage('err', 'Select Date');
      return;
    }
    // fetchFilteredData('results', filters);
    (async () => {
      try {
        const response = await post('api/commonTask/listPatientDocs', {
          patientId: patientId,
          mode: filters.filterType,
          fromDate: filters.filterType === 'range' ? filters.startDate : '',
          toDate: filters.filterType === 'range' ? filters.endDate : '',
        });
        setDocumentData((prev) => ({
          ...prev,
          documentss: response.data.patDocsList || [],
        }));
      } catch (error) {
        setUiMessage('err', error.message);
      }
    })();
  }, [patientId, tabFilters.documentss]);

  useEffect(() => {
    const filters = tabFilters.progressNotes;

    // Avoid empty date range triggering request
    if (
      filters.filterType === 'range' &&
      (!filters.startDate || !filters.endDate)
    ) {
      // setUiMessage('err', 'Select Date');
      return;
    }
    // fetchFilteredData('results', filters);
    (async () => {
      try {
        const response = await post('api/commonTask/listProgressNotes', {
          patientId: patientId,
          mode: filters.filterType,
          fromDate: filters.filterType === 'range' ? filters.startDate : '',
          toDate: filters.filterType === 'range' ? filters.endDate : '',
        });
        setDocumentData((prev) => ({
          ...prev,
          progressNotes: response.data.progressNotesList || [],
        }));
      } catch (error) {
        setUiMessage('err', error.message);
      }
    })();
  }, [patientId, tabFilters.progressNotes]);

  useEffect(() => {
    const filters = tabFilters.clinicalSummary;
    // Avoid empty date range triggering request
    if (
      filters.filterType === 'range' &&
      (!filters.startDate || !filters.endDate)
    ) {
      // setUiMessage('err', 'Select Date');
      return;
    }
    // fetchFilteredData('results', filters);
    (async () => {
      try {
        const response = await post(
          'api/commonTask/listClinicalSummaryReport',
          {
            patientId: patientId,
            mode: filters.filterType,
            fromDate: filters.filterType === 'range' ? filters.startDate : '',
            toDate: filters.filterType === 'range' ? filters.endDate : '',
          },
        );
        setDocumentData((prev) => ({
          ...prev,
          clinicalSummary: response.data.reportList || [],
        }));
      } catch (error) {
        setUiMessage('err', error.message);
      }
    })();
  }, [patientId, tabFilters.clinicalSummary]);

  const attachSelectedDocuments = () => {
    const docsArray = Object.values(selectedChildDocs);

    //emptying the store duplicate referral docs
    const parentKeySet = new Set(Object.keys(selectedDocs));
    const filteredArray = allReferralDocs.filter(
      (item) => !parentKeySet.has(item.sectionId),
    );
    // dispatch(handAllReferralDocs(filteredArray));

    setSelectedDocs(selectedChildDocs);
    function formatDocuments(rawArray = []) {
      return rawArray.map((item) => {
        // -------------------------------
        // 1️⃣ Face Sheet (patientSheet)
        // -------------------------------
        if (item.docsSection === 'patientFaceSheet') {
          return {
            sectionId: `patientFaceSheet_${item.id}`,
            docsSection: 'patientFaceSheet',
            docsTitle: 'Patient Demographics & Contact Information',
            docsId: item.id,
            docsName: item.fileName,
            docsUrl: item.file_url,
            docsDate: item?.added_date,
          };
        }

        // -------------------------------
        // 1️⃣ Lab Results (patientLabResults)
        // -------------------------------
        if (item.docsSection === 'results') {
          return {
            sectionId: `results_${item.id}`,
            docsSection: 'results',
            docsTitle: item?.procedure_name,
            docsId: item.id,
            docsName: item.fileName,
            docsUrl: item.file_url,
            docsDate: item?.report_date_time,
          };
        }

        // -------------------------------
        // 1️⃣ Patient Documents (patientDocuments)
        // -------------------------------
        if (item.docsSection === 'documentss') {
          return {
            sectionId: `documentss_${item.id}`,
            docsSection: 'documentss',
            docsTitle: 'Advanced Directive',
            docsId: item.id,
            docsName: item.fileName,
            docsUrl: item.file_url,
            docsDate: item?.doc_date,
          };
        }

        // -------------------------------
        // 2️⃣ Progress Notes
        // -------------------------------
        if (item.docsSection === 'progressNotes') {
          return {
            sectionId: `progressNotes_${item.id}`,
            docsSection: 'progressNotes',
            // docsTitle: 'Initial Consultation Note',
            docsTitle: item?.tovName,
            docsId: item.id,
            docsName: item.fileName,
            docsUrl: item.file_url,
            docsDate: item?.consult_date,
            providerName: item.providerName || '',
            signStatus: item.sign_status || '0',
          };
        }

        // -------------------------------
        // 3️⃣ Clinical Summary
        // -------------------------------
        if (item.docsSection === 'clinicalSummary') {
          return {
            sectionId: `clinicalSummary_${item.id}`,
            docsSection: 'clinicalSummary',
            docsTitle: 'Clinical Summary docs',
            docsId: item.id,
            docsName: item.report_pdf,
            docsUrl: item.file_url,
            docsDate: item.date_added,
          };
        }

        // -------------------------------
        // Unknown type → return minimal object
        // -------------------------------
        return {
          sectionId: `unknown_${item.id || Math.random()}`,
          docsSection: 'unknown',
          docsTitle: 'Unknown',
          docsId: String(item.id || 0),
          docsName:
            item.file_name || item.fileName || item.report_pdf || 'unknown',
          docsUrl: item.file_url || item.fileUrl || '',
          docsDate: item.date_added || item.added_date,
        };
      });
    }

    const formattedDocs = formatDocuments(docsArray);
    const mergedDocs = [
      ...new Map(
        [...filteredArray, ...formattedDocs].map((item) => [
          item.sectionId,
          item,
        ]),
      ).values(),
    ];

    dispatch(handAllReferralDocs(mergedDocs));
    // dispatch(handAllReferralDocs([...allReferralDocs, ...formattedDocs]));
    closePopup();
  };

  const closePopupCheck = () => {
    function haveSameKeys(parentObj, childObj) {
      const parentKeys = Object.keys(parentObj);
      const childKeys = Object.keys(childObj);

      if (parentKeys.length !== childKeys.length) {
        return false;
      }

      const childKeySet = new Set(childKeys);

      return parentKeys.every((key) => childKeySet.has(key));
    }
    const popupAlter = haveSameKeys(selectedDocs, selectedChildDocs);
    if (popupAlter) {
      closePopup();
    } else {
      setAlertPopup(true);
    }
  };

  const selectedCount = Object.keys(selectedChildDocs).length;

  return (
    <>
      <div className="modalBackground">
        <div
          className="popup active"
          id="attachDocPopup"
          // style={{ opacity: 'unset', visibility: 'unset' }}
        >
          <div className="popup__content p-0 lg overflow-hidden">
            <div className="popup-header border-b-1 border-b-lightgray p-4">
              <h2 className="fw-500">Attach Documents from Patient Chart</h2>
              <span
                className="close-btn"
                id="closeBtn"
                onClick={closePopupCheck}
              >
                &times;
              </span>
            </div>

            <div className="popup-body border-b-1 border-b-lightgray">
              <div className="tabContainer flex overflow-hidden">
                {/* Tabs Sidebar */}
                <div className="tabContainer__tabs flex flex-col items-start border-r-1 border-r-lightgray p-3">
                  {[
                    {
                      id: 'patientFaceSheet',
                      title: 'Patient Face Sheet',
                      icon: './images/user.svg',
                      count: documentData.faceSheet.length,
                    },
                    {
                      id: 'results',
                      title: 'Results',
                      icon: './images/list-file-black.svg',
                      count: documentData.results.length,
                    },
                    {
                      id: 'documentss',
                      title: 'Documents',
                      icon: './images/folder-black.svg',
                      count: documentData.documentss.length,
                    },
                    {
                      id: 'progressNotes',
                      title: 'Progress Notes',
                      icon: './images/file-black.svg',
                      count: documentData.progressNotes.length,
                    },
                    {
                      id: 'clinicalSummary',
                      title: 'Clinical Summary',
                      icon: './images/padnote-black.svg',
                      count: documentData.clinicalSummary.length,
                    },
                  ].map((tab) => (
                    <div
                      key={tab.id}
                      className={`tabContainer__tab flex justify-between items-center p-2 fs-xs cursor-pointer rounded-md ${
                        activeTab === tab.id ? 'active' : ''
                      }`}
                      data-tab={tab.id}
                      onClick={() => setActiveTab(tab.id)}
                    >
                      <div className="flex gap-2">
                        <img src={tab.icon} width="15" alt="" />
                        <span className="">{tab.title}</span>
                      </div>
                      <span className="fw-400 bg-lightgray text-black rounded-xl py-1 px-3">
                        {tab.count}
                      </span>
                    </div>
                  ))}
                </div>
                      

                {/* Tab Contents */}
                <div className="tabContainer__content flex-1 active">
                  {activeTab === 'patientFaceSheet' && (
                    <DocumentTab
                      classActive={
                        activeTab === 'patientFaceSheet' ? 'active' : ''
                      }
                      patientId={patientId}
                      tabId="patientFaceSheet"
                      title="Patient Face Sheet Documents"
                      icon="./images/user-blue.svg"
                      data={documentData.faceSheet.map((d) => ({
                        ...d,
                        url: `/temp_attachments/${d.file_name}`,
                        iconClass: 'lightblue',
                      }))}
                      selectedChildDocs={selectedChildDocs}
                      toggleDocSelection={toggleDocSelection}
                      dateFilterEnabled={false}
                      handleReload={handleReload}
                    />
                  )}
                  {activeTab === 'results' && (
                    <DocumentTab
                      classActive={activeTab === 'results' ? 'active' : ''}
                      tabId="results"
                      title="Results Documents"
                      icon="./images/list-file.svg"
                      data={documentData.results.map((d) => ({
                        ...d,
                        url: `/temp_attachments/${d.result_file}`,
                        iconClass: 'lightgreen',
                      }))}
                      selectedChildDocs={selectedChildDocs}
                      toggleDocSelection={toggleDocSelection}
                      filterState={tabFilters.results}
                      onDateChange={(value) => {
                        setTabFilters((prev) => ({
                          ...prev,
                          results: { ...prev.results, ...value },
                        }));
                      }}
                    />
                  )}
                  {activeTab === 'documentss' && (
                    <DocumentTab
                      classActive={activeTab === 'documentss' ? 'active' : ''}
                      tabId="documentss"
                      title="Documents"
                      icon="./images/folder.svg"
                      data={documentData.documentss.map((d) => ({
                        ...d,
                        url: `/uploads/patientDocuments/${d.attachments}`,
                        iconClass: 'lightorange',
                      }))}
                      selectedChildDocs={selectedChildDocs}
                      toggleDocSelection={toggleDocSelection}
                      filterState={tabFilters.documentss}
                      onDateChange={(value) => {
                        setTabFilters((prev) => ({
                          ...prev,
                          documentss: { ...prev.documentss, ...value },
                        }));
                      }}
                    />
                  )}
                  {activeTab === 'progressNotes' && (
                    <DocumentTab
                      classActive={
                        activeTab === 'progressNotes' ? 'active' : ''
                      }
                      tabId="progressNotes"
                      title="Progress Notes Documents"
                      icon="./images/file.svg"
                      data={documentData.progressNotes.map((d) => ({
                        ...d,
                        iconClass: 'lightvoilet',
                      }))}
                      selectedChildDocs={selectedChildDocs}
                      toggleDocSelection={toggleDocSelection}
                      filterState={tabFilters.progressNotes}
                      onDateChange={(value) => {
                        setTabFilters((prev) => ({
                          ...prev,
                          progressNotes: { ...prev.progressNotes, ...value },
                        }));
                      }}
                    />
                  )}
                  {activeTab === 'clinicalSummary' && (
                    <DocumentTab
                      classActive={
                        activeTab === 'clinicalSummary' ? 'active' : ''
                      }
                      tabId="clinicalSummary"
                      title="Clinical Summary"
                      icon="./images/padnote.svg"
                      data={documentData.clinicalSummary.map((d) => ({
                        ...d,
                        url: `/uploads/reports/patientClinicalSummaryReport/${d.report_pdf}`,
                        iconClass: 'lightblue',
                      }))}
                      selectedChildDocs={selectedChildDocs}
                      toggleDocSelection={toggleDocSelection}
                      filterState={tabFilters.clinicalSummary}
                      onDateChange={(value) => {
                        setTabFilters((prev) => ({
                          ...prev,
                          clinicalSummary: {
                            ...prev.clinicalSummary,
                            ...value,
                          },
                        }));
                      }}
                    />
                  )}
                </div>
              </div>
            </div>

            <div className="popup-footer flex justify-between items-center p-4">
              <input type="hidden" id="docPatId" value={patientId} />
              <p className="text-gray fs-xs mb-0">
                <span className="selectedDocCount">{selectedCount}</span>{' '}
                document(s) selected
              </p>
              <div className="flex gap-3">
                <button
                  className="btn-outline-dark rounded-md"
                  onClick={closePopupCheck}
                >
                  Cancel
                </button>
                <button
                  className="btn-primary rounded-md"
                  onClick={attachSelectedDocuments}
                >
                  Attach Selected(
                  <span className="selectedDocCount">{selectedCount}</span>)
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {alertPopup && (
        <ConfirmDialog
          title={`Confirmation`}
          bodytext={`Are you sure you want to close this popup? Unsaved changes will be discarded.`}
          closeDialog={() => setAlertPopup(false)}
          successDialog={closePopup}
          // sucPrams={sucPrams}
        />
      )}
    </>
  );
};

export default AttachDocumentsPopup;